import React from "react";
import propTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
const TargetGroupComponents = ({ clicksData }) => {
  return (
    <>
      {clicksData?.target_group_data?.length ? (
        <>
          <h4 className="conitems__title text-dark fw-bold">
            People we work with
          </h4>
          <ul className="target__list m-0 ps-2">
            {clicksData.target_group_data.map((item, idx) => (
              <li className="text-gray position-relative" key={idx}>
                {item.label}
              </li>
            ))}
          </ul>
        </>
      ) : (
        ""
      )}
    </>
  );
};
TargetGroupComponents.propTypes = {
  history: propTypes.object,
};
export default TargetGroupComponents;
